import React from "react"
import { default as Layout } from "../templates/LayoutSingle"

import SegmentSettings from "../large/SegmentSettings"

const Setting = props => (
  <Layout>
    <SegmentSettings />
  </Layout>
)

export default Setting



// WEBPACK FOOTER //
// ./src/pages/Settings.js